import { css } from 'linaria';

export const header = css`
  text-transform: uppercase;
`;
